import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { NgModule } from '@angular/core';
import { SignUpFormComponent } from './sign-up-form.component';
import { EnrollEmailDuplicateModule } from '../enrollEmailDuplicate/enroll-email-duplicate.module';
import { EqualValidatorModule } from '../equalValidator/equal-validator.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    EnrollEmailDuplicateModule,
    EqualValidatorModule,
    MatDatepickerModule,
  ],
  declarations: [SignUpFormComponent],
  exports: [SignUpFormComponent],
})
export class SignUpFormModule {}
